import { object, string } from "yup";
import { FormikActions, FormikProps } from "formik";

import { reduceFieldSettings, TItem } from "../../../utils/reduceFieldSettings";

export const FORM_TITLE = "Update Profile";

const list: Array<TItem> = [
  {
    name: "displayName",
    type: "text",
    initValue: "",
    placeholder: "Display Name",
    validationRule: string(),
  },
  /*{ // TODO: implement later
    name: "photoURL",
    type: "text",
    initValue: "",
    placeholder: "Photo URL",
    validationRule: string(),
  },*/
];

const { initialValues, fields, validationRuleObject } = reduceFieldSettings(list);

const validationSchema = object().shape(validationRuleObject);

export type ValueTypes = typeof initialValues;

export type FormTypes = FormikProps<ValueTypes>;

export type FormActionTypes = FormikActions<ValueTypes>;

export {
  fields,
  initialValues,
  validationSchema,
};
